import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('UNREAD_ROOMS').plugin(axiosPlugin);

let fetchUnreadRoomsAction = redux.fetchActionGetOne();

export const TYPES = redux.types;

export const fetchUnreadRooms = () => fetchUnreadRoomsAction(`/users/me/rooms/unread`);
export const resetUnreadRooms = () => redux.actions.reset();

export const userUnreadRooms = redux.reducer();